import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Button from '../../../../shared/components/button';
import ParticipantIcon from '../../../../shared/components/participant-icon';
import { i18n } from '../../../../shared/helpers/i18n';
import { ACTION, FEATURE } from '../../../../shared/helpers/logger-enums';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { useTypedSelector } from '../../../../shared/hooks/useTypedSelector';
import { logger } from '../../features/waiting-rooms';
import { admitWaitingRoomPeerAction } from '../../features/waiting-rooms/slice';
import { selectCanAdmit, selectConferenceIsFull, selectContactName } from '../../selectors';
import { WaitingRoomPeerState } from '../../types';
import styles from './styles.css';

interface WaitingRoomPeerProps {
    peer: WaitingRoomPeerState;
}

export const WaitingRoomPeer = ({ peer }: WaitingRoomPeerProps) => {
    const dispatch = useDispatch();
    const onAdmitClick = useCallback(
        (id: string) => {
            dispatch(admitWaitingRoomPeerAction({ peerId: id }));
        },
        [dispatch]
    );
    const conferenceIsFull = useSelector(selectConferenceIsFull);
    const canAdmit = useSelector(selectCanAdmit);
    const contactName = useTypedSelector((state) => selectContactName(state, peer.mssngrGuid));
    return (
        <div key={peer.id} className={styles.peer}>
            <ParticipantIcon participantId={peer.id} width={40} height={40} />
            <div className={styles.peerDisplayName}>{contactName ?? peer.displayName}</div>
            <div className={styles.peerControls}>
                {!conferenceIsFull && canAdmit ? (
                    <Button
                        view="neutral"
                        size="sm"
                        onClick={() => {
                            countMetrika('waiting_rooms', 'waiting_list', 'let_user_come_in_press');

                            logger.startFeatureDelta({
                                feature: FEATURE.WAITING_ROOM,
                                action: ACTION.ALLOW_PARTICIPANT,
                                id: peer.id,
                            });

                            onAdmitClick(peer.id);
                        }}
                        isPending={peer.isAdmitting}
                    >
                        {i18n('common', 'admit')}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};
